(function () {
  const bar = document.querySelector('.daeker-scrollbar');
  const thumb = bar && bar.querySelector('.daeker-scrollbar__thumb');
  if (!bar || !thumb) return;

  const DESKTOP_MQ = window.matchMedia('(min-width: 1025px)');
  let hideTimer = null;
  let dragging = false;
  let dragStartY = 0;
  let dragStartScroll = 0;

  function isDesktop() {
    return DESKTOP_MQ.matches;
  }

  function getMetrics() {
    const scrollHeight = document.documentElement.scrollHeight;
    const clientHeight = document.documentElement.clientHeight;
    const scrollTop = window.scrollY;
    const scrollable = scrollHeight - clientHeight;
    const trackHeight = clientHeight - 4;
    const thumbHeight =
      scrollable <= 0 ? trackHeight : Math.max((clientHeight / scrollHeight) * trackHeight, 48);
    const maxTop = Math.max(trackHeight - thumbHeight, 0);

    return { scrollable, scrollTop, thumbHeight, maxTop, trackHeight };
  }

  function updateThumb() {
    if (!isDesktop()) {
      bar.classList.remove('is-active');
      bar.hidden = true;
      return;
    }

    const { scrollable, scrollTop, thumbHeight, maxTop } = getMetrics();

    if (scrollable <= 0) {
      bar.hidden = true;
      return;
    }

    bar.hidden = false;
    const top = (scrollTop / scrollable) * maxTop;
    thumb.style.height = thumbHeight + 'px';
    thumb.style.transform = 'translateY(' + top + 'px)';
  }

  function showBar() {
    if (!isDesktop() || bar.hidden) return;
    bar.classList.add('is-active');
    window.clearTimeout(hideTimer);
    hideTimer = window.setTimeout(function () {
      if (!dragging && !bar.matches(':hover')) {
        bar.classList.remove('is-active');
      }
    }, 900);
  }

  function onScroll() {
    if (dragging) return;
    updateThumb();
    showBar();
  }

  thumb.addEventListener('mousedown', function (event) {
    if (!isDesktop()) return;
    dragging = true;
    dragStartY = event.clientY;
    dragStartScroll = window.scrollY;
    bar.classList.add('is-active');
    document.documentElement.classList.add('daeker-scrollbar-dragging');
    event.preventDefault();
  });

  window.addEventListener(
    'mousemove',
    function (event) {
      if (!dragging) return;

      const { scrollable, maxTop, thumbHeight, trackHeight } = getMetrics();
      if (scrollable <= 0) return;

      const deltaY = event.clientY - dragStartY;
      const scrollDelta = (deltaY / Math.max(trackHeight - thumbHeight, 1)) * scrollable;
      window.scrollTo(0, dragStartScroll + scrollDelta);
      updateThumb();
    },
    { passive: true }
  );

  window.addEventListener('mouseup', function () {
    if (!dragging) return;
    dragging = false;
    document.documentElement.classList.remove('daeker-scrollbar-dragging');
    showBar();
  });

  window.addEventListener('scroll', onScroll, { passive: true });
  window.addEventListener('resize', updateThumb, { passive: true });
  DESKTOP_MQ.addEventListener('change', updateThumb);
  updateThumb();
})();
